/**
 * @class Oskari.mapframework.bundle.publisher.event.LayerToolsEditModeEvent
 *
 * Event is sent when user decides to edit layout order
 */
Oskari.clazz.define('Oskari.mapframework.bundle.publisher2.event.LayerToolsEditModeEvent',
/**
 * @method create called automatically on construction
 * @static
 */
function (inMode) {
  this._isInMode = inMode;
}, {
  /** @static @property __name event name */
  __name: 'LayerToolsEditModeEvent',
  /**
   * @method getName
   * @return {String} the name for the event
   */
  getName: function getName() {
    return this.__name;
  },
  /**
   * @method getName
   * @return {String} the name for the event
   */
  isInMode: function isInMode() {
    return this._isInMode;
  }
}, {
  /**
   * @property {String[]} protocol array of superclasses as {String}
   * @static
   */
  'protocol': ['Oskari.mapframework.event.Event']
});